import { render } from "./ProfileEditPage.vue?vue&type=template&id=509d71bb&scoped=true&ts=true"
import script from "./ProfileEditPage.vue?vue&type=script&lang=ts"
export * from "./ProfileEditPage.vue?vue&type=script&lang=ts"

import "./ProfileEditPage.vue?vue&type=style&index=0&id=509d71bb&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509d71bb"]])

export default __exports__